import React from "react";
import { Convocatoria } from "../../../models/ConvocatoriasModel/convocatoria.model";
import { PostulacionBannerShared } from "../../../components/Generales/PostulacionBannerShared";

interface IProps {
  convocatorias: Convocatoria;
}

export const BannerPostulacion: React.FC<IProps> = (props: IProps) => {
  return (
    <PostulacionBannerShared
      convocatorias={props.convocatorias}
      role="participantes"
      showExpression={true}
      supportSMImage={true}
    />
  );
};
